import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import { ACCORDION_CONTENT_DISPLAY_NAME, ACCORDION_TITLE_DISPLAY_NAME } from './Accordion.constants';
import { findComponentsByType } from '../../../../services/components';
import { createComponent } from '../../services/components';
export function isAccordionControlled() {
  var titleComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var contentComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (_isEmpty(titleComponents) || _isEmpty(contentComponents)) {
    return true;
  }
  if (titleComponents.length !== contentComponents.length) {
    return true;
  }
  var activeValues = [].concat(_toConsumableArray(titleComponents), _toConsumableArray(contentComponents)).map(function (component) {
    return _get(component, 'props.active');
  });
  return activeValues.some(function (value) {
    return !_isNil(value);
  });
}
export function getInitialActiveIndexes(defaultActiveIndexes) {
  if (_isNumber(defaultActiveIndexes)) {
    return [defaultActiveIndexes];
  }
  if (_isNil(defaultActiveIndexes) || _isEmpty(defaultActiveIndexes)) {
    return [];
  }
  if (_isArray(defaultActiveIndexes)) {
    return defaultActiveIndexes;
  }
  return [defaultActiveIndexes];
}
export function getNextActiveIndexes(previousActiveIndexes, index, exclusive) {
  if (exclusive) {
    if (index === _get(previousActiveIndexes, '[0]')) {
      return [];
    }
    return [index];
  }
  if (previousActiveIndexes.includes(index)) {
    return previousActiveIndexes.filter(function (activeIndex) {
      return activeIndex !== index;
    });
  }
  return [].concat(_toConsumableArray(previousActiveIndexes), [index]);
}
export function injectUncontrolledProps(children) {
  var activeIndexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var onTitleClick = arguments.length > 2 ? arguments[2] : undefined;
  var titleComponents = findComponentsByType(children, ACCORDION_TITLE_DISPLAY_NAME).map(function (component, index) {
    var active = activeIndexes.includes(index);
    return createComponent(component, {
      active: active,
      index: index,
      onClick: onTitleClick
    });
  });
  var contentComponents = findComponentsByType(children, ACCORDION_CONTENT_DISPLAY_NAME).map(function (component, index) {
    var active = activeIndexes.includes(index);
    return createComponent(component, {
      active: active,
      index: index
    });
  });
  return titleComponents.reduce(function (result, item, index) {
    return result.concat(item, contentComponents[index]);
  }, []);
}